export default __webpack_public_path__ + "static/media/icon_youtube.8795c761.svg";